import React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useIntl } from 'react-intl';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import { GroupFormInput } from '../../types';

const GroupFormSchema = Yup.object({
  name: Yup.string().required('El nombre es requerido'),
});

export interface GroupFormProps {
  onSubmit: (data: GroupFormInput) => void;

  groupFormData?: GroupFormInput;
  isSubmitting: boolean;
  submitError?: string;
}

const GroupForm = (props: GroupFormProps) => {
  const intl = useIntl();
  const { onSubmit, isSubmitting, submitError, groupFormData } = props;

  const { handleSubmit, formState, control } = useForm<GroupFormInput>({
    resolver: yupResolver(GroupFormSchema),
    defaultValues: groupFormData,
  });

  return (
    <Form sx={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)} isSubmitting={isSubmitting} submitError={submitError} formState={formState}>
      <FormTextField
        control={control}
        type="text"
        rules={{ required: true }}
        name="name"
        defaultValue=""
        label={intl.formatMessage({ id: 'field.name.label' })}
        fullWidth
      />
    </Form>
  );
};

export default GroupForm;
